import React from "react";

function Slide() {
    const scrollToDestination = () => {
        const destinationDetailElement = document.getElementById('destination-detail');
        if (destinationDetailElement) {
            const offsetTop = destinationDetailElement.offsetTop;
            window.scrollTo({top: offsetTop - 100, behavior: 'smooth'});
        }
    };


    return (
        <div className="slide-container" style={{position: 'relative', width: '100%', marginTop: '80px'}}>
            <img
                src={'https://res.cloudinary.com/drvydie5q/image/upload/v1720719327/Dynamic%20folders/zk4bwlwormxtcupxxfbd.jpg'}
                alt="Gallery"
                style={{width: '100%', height: '650px'}}
            />
            <div className="centered-text" style={{
                position: 'absolute',
                top: '42%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: 'white',
                fontSize: '36px',
                fontWeight: 'bold',
                textAlign: 'center',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
            }}>
                Discover Nha Trang city with Us
                <div style={{fontWeight: '500', fontSize: '20px'}}>Welcome to our premier tour booking website, where
                    you can find the best travel packages to destinations all around Nha Trang city. With us, each
                    journey is not just about exploring new places, but also about experiencing diverse cultures and
                    creating unforgettable memories. Let us help you craft beautiful stories on every path you take.
                </div>
                <button
                    onClick={scrollToDestination}
                    style={{
                        marginTop: '20px',
                        padding: '10px 20px',
                        fontSize: '18px',
                        backgroundColor: 'rgb(39, 115, 61)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '30px',
                        cursor: 'pointer',
                        height: '50px',
                        fontWeight: 'bold'
                    }}
                >
                    Explore
                </button>
            </div>
        </div>
    );
}

export default Slide;
